import { JSONSchemaType } from 'ajv';

export interface Identity {
    /*
     * Universally unique identifier of the application
     */
    uuid: string;
    /*
     * Optional - the name of the component
     */
    name?: string;
}

export const identitySchema: JSONSchemaType<Identity> = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1,
        },
        name: {
            type: 'string',
            nullable: true,
        },
    },
    required: ['uuid'],
    additionalProperties: false,
};
